/**
 * 值得买/薅羊毛单品中间页
 */


$(function () {
    let len_r = $('.price_comparison .list .dp-item').length;
    let len_l = $('.menuWrap1 .menuList3>li').length;

    // 比价商品较少时，不显示下载工具条
    if (len_r) {
        if (len_r < 4) {
            if (! len_l ) {
                if (len_r === 1) {
                    $('.menuWrap1 .toolBox:eq(2)').hide()
                }
            } else {
                if ((len_r - len_l) === 1) {
                    $('.menuWrap1 .toolBox:eq(1), .menuWrap1 .toolBox:eq(2)').hide()
                } else if ((len_r - len_l) === 2) {
                    $('.menuWrap1 .toolBox:eq(2)').hide()
                } else if ((len_r - len_l) === 0) {
                    $('.menuWrap1 .toolBox').hide()
                } else if ((len_r - len_l) === 3) {
                    $('.menuWrap1 .toolBox').hide()
                }
            }
        } else {
            if (len_l) {
                let h_r = $('.price_comparison').height();
                let h_l = $('.menuWrap1 .menuList3').height();
                let diff_h = h_r - h_l;
                if (diff_h < 223) {
                    $('.menuWrap1 .toolBox').hide();
                } else if (diff_h < 223 * 2) {
                    $('.menuWrap1 .toolBox:eq(1), .menuWrap1 .toolBox:eq(2)').hide();
                } else if(diff_h < 223 * 3) {
                    $('.menuWrap1 .toolBox:eq(2)').hide();
                }
            }
        }
    }
});